export const DOCUMENT_TYPES = [
  { id: "contrato-laboral", label: "Contrato laboral" },
  { id: "identificacion", label: "Identificación" },
  { id: "comprobante-domicilio", label: "Comprobante dom." },
  { id: "licencia", label: "Licencia" },
  { id: "certificaciones", label: "Certificaciones" },
];

export const CAPACITACION_TYPES = [
  { id: "induccion", label: "Inducción" },
  { id: "quimicos", label: "Químicos" },
  { id: "seguridad", label: "Seguridad" },
];

export const PERSONAL_FIELDS = [
  { key: "curp", label: "CURP" },
  { key: "rfc", label: "RFC" },
  { key: "nss", label: "NSS" },
  { key: "fechaIngreso", label: "Fecha ingreso", type: "date" },
  { key: "puesto", label: "Puesto" },
  { key: "contrato", label: "Contrato" },
];

export const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
];

export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export function getExpedienteS3Prefix(technicianId) {
  return `RH/expedientes/${technicianId}/`;
}

export function getDocumentS3Subfolder(technicianId, docType) {
  return `${getExpedienteS3Prefix(technicianId)}${docType}`;
}

export function getCapacitacionS3Subfolder(technicianId, capId) {
  return `${getExpedienteS3Prefix(technicianId)}capacitaciones/${capId}`;
}

export function formatExpedienteDate(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "—";
  }
}

export function toDateInputValue(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().split("T")[0];
}
